import { useMutation } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { createRelease, CreateReleaseArgs } from "../releaseAPI";

/**
 * Use this hook to create a release.
 */
const useCreateRelease = () => {
  return useMutation({
    mutationKey: [QUERY_KEYS.CREATE_RELEASE],
    mutationFn: async (runTimeParams: CreateReleaseArgs) => {
      return createRelease(runTimeParams);
    },
    onSuccess: (result) => {
      return result;
    },
    onError: (error: Error) => {
      return error;
    },
  });
};

export default useCreateRelease;
